module.exports = __webpack_public_path__ + "static/media/mondo-new.1f7a45d4.png";